import {FAILED_TO_RECEIVE_EXPENSE_TYPES, GET_EXPENSE_TYPES, RECEIVE_EXPENSE_TYPES} from "./index";

//action that requests the expense types
export function getExpenseTypes() {
    return {
        type: GET_EXPENSE_TYPES
    }
}

//action that receives the expenseTypes
export function receiveExpenseTypes(expenseTypes) {
    return {
        type: RECEIVE_EXPENSE_TYPES,
        payload: expenseTypes
    }
}

//action that receives failed response while requesting the expense types
export function failedToReceiveExpenseTypes(response) {
    return {
        type: FAILED_TO_RECEIVE_EXPENSE_TYPES,
        payload: response
    }
}